import { useGetRemoteLockDevices } from '@/api/keyless/remote-lock/get-remote-lock-devices'
import { useGetRemoteLockConnection } from '@/api/property-keyless/remote-lock/get-remote-lock-connection'

import { remoteLockDefaultValues } from './remote-lock.schema'

// Note: `authorizationCode` is intentionally never pre-filled — the GET response never
// returns it (write-only, single-use), and a fresh code is required on every submit since
// there's no separate "update config only" endpoint (see use-remote-lock-submit.ts).
export const useRemoteLockConnection = (buildingId: number) => {
  const { data, isSuccess, isLoading } = useGetRemoteLockConnection({ buildingId })
  const { data: locks, isLoading: isLoadingDoors } = useGetRemoteLockDevices({ buildingId })

  const values = {
    ...remoteLockDefaultValues,
    shouldAutoAssignApartmentDoorVisitor: data?.shouldAutoAssignApartmentDoorVisitor ?? false,
    staffDefaults: data?.staffDefaults ?? [],
    visitorDefaults: data?.visitorDefaults ?? [],
  }

  return {
    doors: locks ?? [],
    isConfigured: isSuccess,
    isLoading,
    isLoadingDoors,
    values,
  }
}
